// Copyright (c) Silence Laboratories Pte. Ltd.
// This software is licensed under the Silence Laboratories License Agreement.

const Spinner = () => {
  return (
    <div className="bg-[#000] w-[100vw] h-[100vh] flex items-center justify-center">
      <img src="./spinner.svg" />
    </div>
  );
};

export default Spinner;
